import { render, staticRenderFns } from "./MainApp.vue?vue&type=template&id=7572c23f&scoped=true&"
import script from "./MainApp.vue?vue&type=script&lang=js&"
export * from "./MainApp.vue?vue&type=script&lang=js&"
import style0 from "./MainApp.vue?vue&type=style&index=0&id=7572c23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572c23f",
  null
  
)

export default component.exports